import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPageLayout from '../components/ContentPageLayout';

const Widerrufsbelehrung = () => {
  const { t } = useTranslation();

  return (
    <ContentPageLayout>
      {/* Widerrufsbelehrung Hauptbereich */}
      <section className="py-6 bg-white" data-testid="widerrufsbelehrung-page">
        <div className="container mx-auto px-4 sm:px-6 lg:px-2 xl:max-w-[1800px]">
          
          {/* Überschrift */}
          <h1 className="text-lg sm:text-xl font-semibold text-white bg-gray-900 px-6 py-3 rounded-t-lg" data-testid="widerrufsbelehrung-title">
            Widerrufsbelehrung
          </h1>

          {/* Textbereich */}
          <div className="bg-gray-50 rounded-b-xl border border-gray-200 border-t-0 p-6 md:p-8">
                
            {/* Widerrufsrecht */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                Widerrufsrecht
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Verbraucher haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag,
              </p>
              <ul className="space-y-2 mb-4">
                <li className="flex items-start text-sm sm:text-base text-gray-700">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3 mt-2 flex-shrink-0"></span>
                  <span>an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben, oder</span>
                </li>
                <li className="flex items-start text-sm sm:text-base text-gray-700">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3 mt-2 flex-shrink-0"></span>
                  <span>bei mehreren Waren, die getrennt geliefert werden: an dem Sie die letzte Ware in Besitz genommen haben.</span>
                </li>
              </ul>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
              </p>
              <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
                <p className="text-sm sm:text-base text-gray-700 font-semibold">Jannesmann Handels- und Import GbR</p>
                <p className="text-sm sm:text-base text-gray-700">Poststraße 6</p>
                <p className="text-sm sm:text-base text-gray-700">46236 Bottrop</p>
                <p className="text-sm sm:text-base text-gray-700">Deutschland</p>
                <p className="text-sm sm:text-base text-gray-700">E-Mail: info@jannesmann.de</p>
                <p className="text-sm sm:text-base text-gray-700">Telefon: 02041 9877499</p>
              </div>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                mittels einer eindeutigen Erklärung (z. B. per Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Sie können dafür das unten beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
              </p>
            </div>

            {/* Folgen des Widerrufs */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                Folgen des Widerrufs
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Bei Widerruf eines Vertrages über die Lieferung von Waren, die aufgrund ihrer Beschaffenheit nicht normal mit der Post zurückgesandt werden können (z. B. Baumaschinen, Speditionsware), erstatten wir den Kaufpreis der Ware.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Die Kosten der Anlieferung sowie die unmittelbaren Kosten der Rücksendung trägt der Kunde.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Eine Erstattung der Lieferkosten erfolgt nicht, da es sich nicht um eine paketversandfähige Standardlieferung handelt.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf unterrichten, an uns zurückzusenden oder zu übergeben.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Für einen etwaigen Wertverlust der Waren müssen Sie nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.
              </p>
            </div>

            {/* Ausschluss des Widerrufsrechts */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                Ausschluss des Widerrufsrechts
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                Das Widerrufsrecht besteht nicht bei:
              </p>
              <ul className="space-y-2">
                <li className="flex items-start text-sm sm:text-base text-gray-700">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3 mt-2 flex-shrink-0"></span>
                  <span>kundenspezifisch angefertigten Maschinen oder Sonderanfertigungen,</span>
                </li>
                <li className="flex items-start text-sm sm:text-base text-gray-700">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3 mt-2 flex-shrink-0"></span>
                  <span>bereits in Betrieb genommenen und individuell konfigurierten Maschinen,</span>
                </li>
                <li className="flex items-start text-sm sm:text-base text-gray-700">
                  <span className="w-2 h-2 bg-red-600 rounded-full mr-3 mt-2 flex-shrink-0"></span>
                  <span>gewerblichen Käufern (§14 BGB).</span>
                </li>
              </ul>
            </div>

            {/* Muster-Widerrufsformular */}
            <div>
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                Muster-Widerrufsformular
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 italic">
                (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)
              </p>
              <div className="bg-white border border-gray-200 rounded-lg p-6">
                <p className="text-sm sm:text-base text-gray-700 mb-4">
                  <span className="font-semibold">An:</span><br />
                  Jannesmann Handels- und Import GbR<br />
                  Poststraße 6<br />
                  46236 Bottrop<br />
                  Deutschland<br />
                  E-Mail: info@jannesmann.de
                </p>
                <p className="text-sm sm:text-base text-gray-700 mb-4">
                  Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über den Kauf der folgenden Ware:
                </p>
                <div className="space-y-3 text-sm sm:text-base text-gray-700">
                  <p>Bestellt am: ____________________</p>
                  <p>Erhalten am: ____________________</p>
                  <p>Name des/der Verbraucher(s): ____________________</p>
                  <p>Anschrift des/der Verbraucher(s): ____________________</p>
                  <p>Unterschrift (nur bei Mitteilung auf Papier): ____________________</p>
                  <p>Datum: ____________________</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </ContentPageLayout>
  );
};

export default Widerrufsbelehrung;
